import { useLocalSettings } from '@/hooks/useLocalSettings'

export type FontSizePreset = 'small' | 'normal' | 'large'

export const FONT_SIZE_NORMAL = 14

export const FONT_SIZE_PRESETS: Record<FontSizePreset, number> = {
  small: FONT_SIZE_NORMAL - 3,
  normal: FONT_SIZE_NORMAL,
  large: FONT_SIZE_NORMAL + 3,
}

export const useFontSize = (): number => {
  const { getSetting } = useLocalSettings()
  return getSetting('fontSize') ?? FONT_SIZE_NORMAL
}
